'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ShareIcons from './ShareIcons';

var ShareBanner = /*#__PURE__*/function (_Component) {
  _inherits(ShareBanner, _Component);

  function ShareBanner() {
    _classCallCheck(this, ShareBanner);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShareBanner).apply(this, arguments));
  }

  _createClass(ShareBanner, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx("div", {
        className: "share-banner",
        children: /*#__PURE__*/_jsxs("div", {
          className: "share-banner-content",
          children: [/*#__PURE__*/_jsxs("span", {
            className: "share-banner-header",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "results.share.banner.title"
            }), /*#__PURE__*/_jsx("span", {
              className: "share-banner-paragraph",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "results.share.banner.description"
              })
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "share-banner-buttons",
            children: /*#__PURE__*/_jsx(ShareIcons, {})
          })]
        })
      });
    }
  }]);

  return ShareBanner;
}(Component);

export default ShareBanner;